/**
 * v-marquee — seamless infinite ticker (the Play "running line" from the
 * mockups). The directive duplicates the container's content into two
 * side-by-side segments and scrolls the track, so the loop has no visible
 * seam. The scroll keyframes live in src/styles/motion.scss.
 *
 * Usage (put it on the OVERFLOW container; its children are the ticker items):
 *   <div v-marquee>
 *     <span>✂ Salons</span><span>🩺 Clinics</span><span>🧘 Studios</span>
 *   </div>
 *   <div v-marquee="{ duration: 30, reverse: true }">…</div>
 *
 * Binding value: a Number (seconds per loop) or an object:
 *   duration — seconds per loop (default 22, from the mockup)
 *   reverse  — scroll right-to-left → left-to-right (default false)
 *
 * The CSS pauses the animation under prefers-reduced-motion.
 *
 * VUE3-MIGRATION: rename `inserted`→`mounted`. The DOM-building body is
 * unchanged.
 */

function configFromBinding(binding) {
  const v = binding.value
  const cfg = typeof v === 'object' && v !== null ? v : { duration: Number(v) }
  return {
    duration: Number(cfg.duration) || 22,
    reverse: Boolean(cfg.reverse),
  }
}

export const marquee = {
  inserted(el, binding) {
    const { duration, reverse } = configFromBinding(binding)

    el.classList.add('play-marquee')

    const track = document.createElement('div')
    track.className = 'play-marquee__track'
    if (reverse) track.classList.add('play-marquee__track--reverse')
    track.style.setProperty('--play-marquee-dur', `${duration}s`)

    const seg = document.createElement('div')
    seg.className = 'play-marquee__seg'
    while (el.firstChild) seg.appendChild(el.firstChild)

    const clone = seg.cloneNode(true)
    clone.setAttribute('aria-hidden', 'true')

    track.appendChild(seg)
    track.appendChild(clone)
    el.appendChild(track)
  },
}

export default marquee
